import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {User} from "../type/user";
import {UserRole} from "../type/user-role";

@Component({
    selector: 'app-user-add',
    templateUrl: './user-add.component.html',
})
export class UserAddComponent implements OnInit {
    node = 'user';
    roleNode = 'user-role';

    user: User = User;
    userRoles: [UserRole] = [UserRole];

    constructor(
        private dataService: DataService,
        private apiService: ApiService,
        private location: Location
    ) {
    }

    ngOnInit() {
        this.dataService.refresh();
        this.getUserRoles();
    }

    getUserRoles(): void {
        this.apiService.getAll(this.roleNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.userRoles = [UserRole];
                } else {
                    this.userRoles = response.json().data;
                }
            });
    }

    onFormSubmit(formData) {
        var data = {
            firstname: formData.value.firstname,
            lastname: formData.value.lastname,
            email: formData.value.email,
            password: formData.value.password,
            user_status: formData.value.user_status,
            user_role_id: formData.value.user_role_id,
        };
        this.apiService.postNew(this.node, data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: User added successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/users/user-add.component.ts